import { Injectable } from '@angular/core';
import { InHomeBookingResult } from '@Medology/ng-findalab';
import { AnalyteCareLoadCartRequest } from '@models/analyte-care-load-cart-request';
import { InHomeBookingReloadOrderService } from '@services/in-home-booking-reload-order.service';

@Injectable({
  providedIn: 'root',
})
export class STDcheckOrderService extends InHomeBookingReloadOrderService {
  /**
   * Reloads the cart with the booked address state when an in-home collection booking is submitted.
   */
  protected override listenForBookingSubmission(): void {
    this.inHomeService.bookingSubmitted$.subscribe((result: InHomeBookingResult) => {
      const request = new AnalyteCareLoadCartRequest({
        tests: this.storage.tests,
        coupon: this.storage.coupon?.coupon_code ?? null,
        state_short_name: result.address.state,
      });

      this.loadCartRequest(request).subscribe();
    });
  }
}
